






import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import EmailTemplateForm from '../components/Form.vue'

@Component({
  components: {
    EmailTemplateForm,
  }
})
export default class EmailTemplateCreatePage extends Vue {
  breadcrumbs = [
    { url: '/admin/emails/templates', text: 'Email Templates' },
    { url: '/admin/emails/templates/create', text: 'Create' }
  ]

  errors: { code: string }[] = []

  async createTemplate(data: any) {
    this.errors = []
    try {
      await axios.post('/emails/templates', data)
      this.$store.dispatch('showSuccess', 'Template created successfully')
      this.$router.push('/admin/emails/templates')
    } catch (err) {
      if (err.response) {
        if (err.response.data.code && err.response.data.code === 'NAME_TAKEN') {
          this.errors.push({ code: 'NAME_TAKEN' })
        }

        if (!err.response.data.code) {
          this.$store.dispatch('showError', `Error creating template: ${err.response.data.message}`)
        }
      } else {
        this.$store.dispatch('showError', 'Error creating template')
      }
    }
  }
}
